module.exports = __webpack_public_path__ + "static/media/instaIcon.942bf62b.svg";